<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-img
        :src="require('@/assets/square-logo.png')"
        contain
        max-width="128"
        min-height="78"
        width="100%"
        class="logo-filter"
      />

      <base-title
        size="body-1"
        space="4"
        title="c o n s u l t a n c y"
        weight="regular"
      />

      <base-body>
        is a consulting company providing services and technology solutions. We
        stand beside all businesses to help them shape and drive their
        transformation journey. We are always at the forefront of innovation.
      </base-body>
      <base-btn class="mb-12" color="white" outlined href="/privacy-policy">
        Privacy Policy
      </base-btn>
      <br />

      <!-- <base-img
        :src="require('@/assets/csr.png')"
        style="filter: brightness(0) invert(1)"
        width="100px"
        class="text-center"
      />-->
      <!-- <a class="white--text" outlined href="/coporate-social-responsibility">
        <b> Corporate Social Responsibility</b>
      </a>-->
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseInfo",

  props: {
    title: String,
    dark: Boolean,
  },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text: "Kenwyn Consultancy Services PVT. Ltd . <br>  No 20, <br> 2nd Lane Linganagar,<br> Trincomalee",
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: "+94-26 205 5830",
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "info@myeduvisa.com",
      },
    ],
  }),
};
</script>

<style scoped>
.logo-filter {
  filter: grayscale(100%);
}
</style>
